import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/onboarding/income')({
  component: () => <Navigate to='/onboarding' />,
})
